import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { isDecisionMaker } from './decisionMaker';
import { fetchGammaPetitionDetailsExperiments } from './experiments';
import { isGdprConsentProvided } from './gdprConsentProvided';
import { isShareVisualsExperimentEnabled } from './isShareVisualsExperimentEnabled';
import { isSignatureThermometerEnabled } from './isSignatureThermometerEnabled';
import { isStickySignatureBlockExperimentEnabled } from './isStickySignatureBlockExperimentEnabled';

export type PetitionDetailsPageUserData = {
	decisionMaker: boolean;
	gdprConsentProvided: boolean;
	signatureThermometerEnabled: boolean;
	stickySignatureBlockExperimentEnabled: boolean;
	isSunriseEnabled: boolean;
	shareVisualsExperimentEnabled: boolean;
	isMobileAppDownloadBannerEnabled: boolean;
};

export async function getPetitionDetailsPageUserData(
	utilityContext: UtilityContext,
	slugOrId: string,
	{ decisionMakerHash, isGuest }: { decisionMakerHash?: string; isGuest: boolean },
): Promise<PetitionDetailsPageUserData> {
	// TODO: We probably want to fetch all the experiments with the same experiments query
	// but for now we are fetching them separately
	const [
		decisionMaker,
		gdprConsentProvided,
		signatureThermometerEnabled,
		stickySignatureBlockExperimentEnabled,
		experiments,
		shareVisualsExperimentEnabled,
	] = await Promise.all([
		!isGuest || decisionMakerHash ? isDecisionMaker(utilityContext, { slugOrId, decisionMakerHash }) : false,
		isGdprConsentProvided(utilityContext),
		isSignatureThermometerEnabled(utilityContext),
		isStickySignatureBlockExperimentEnabled(utilityContext),
		fetchGammaPetitionDetailsExperiments(utilityContext),
		isShareVisualsExperimentEnabled(utilityContext),
	]);

	return {
		decisionMaker,
		gdprConsentProvided,
		signatureThermometerEnabled,
		stickySignatureBlockExperimentEnabled,
		isSunriseEnabled: experiments.sunriseSupportersV1.variation === 'enabled',
		shareVisualsExperimentEnabled,
		isMobileAppDownloadBannerEnabled: experiments.mobileAppDownloadBanner.variation === 'enabled',
	};
}
